import './InspirationContent.css';
import { IoClose } from 'react-icons/io5';
import { HiMiniArrowLongLeft, HiMiniArrowLongRight } from 'react-icons/hi2';
import { useDisplayWidgetContext } from '../../DisplayWidget/utils/context';
import HotspotMedia from '../../../common/ImageHotspot/HotspotMedia';
import { addUTMToURL, calculatePrice, getCurrentSymbol, PriceDisplay } from '../../../Helpers/Helpers';
import { FaInstagram, FaTiktok, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { SiTrustpilot } from 'react-icons/si';
import { FaXTwitter } from 'react-icons/fa6';

export default function InspirationContent(props) {
  const { handleNext, handlePrev, onClose, mediaData } = props;
  const { data, layout, isGoogle, shopifyData } = useDisplayWidgetContext();

  const SourceIcon = ({ socialUrl, fontSize = 22 }) => {
    if (socialUrl?.toLowerCase()?.includes('instagram')) {
      return <FaInstagram className="icon_shadow" fontSize={fontSize} />;
    }
    if (socialUrl?.toLowerCase()?.includes('tiktok')) {
      return <FaTiktok className="icon_shadow" fontSize={fontSize} />;
    }
    if (socialUrl?.toLowerCase()?.includes('twitter')) {
      return <FaXTwitter className="icon_shadow" fontSize={fontSize} />;
    }
    if (socialUrl?.toLowerCase()?.includes('linkedin')) {
      return <FaLinkedin className="icon_shadow" fontSize={fontSize} />;
    }
    if (socialUrl?.toLowerCase()?.includes('youtube')) {
      return <FaYoutube className="icon_shadow" fontSize={fontSize} />;
    }
    if (socialUrl?.toLowerCase()?.includes('trustpilot')) {
      return <SiTrustpilot className="icon_shadow" fontSize={fontSize} />;
    }
    return '';
  };
  return (
    <idk-div class="inspiration_modal zid-relative zid-h-full zid-flex">
      <idk-span class="inspiration_close_btn" onClick={() => onClose()}>
        <IoClose size={24} color="#928b80" />
      </idk-span>
      <idk-span onClick={() => handlePrev()} class="inspiration_arrow_btn left_arrow">
        <HiMiniArrowLongLeft size={24} color="#928b80" />
      </idk-span>
      <idk-span onClick={() => handleNext()} class="inspiration_arrow_btn right_arrow">
        <HiMiniArrowLongRight size={24} color="#928b80" />
      </idk-span>
      <idk-div class="inspiration_container">
        <idk-div class="inspiration_content">
          <idk-div class="inspiration_image">
            <HotspotMedia
              layout={layout}
              autoPlay={layout?.popupSettings?.popupVideoAutoPlay}
              isMuted={layout?.popupSettings?.popupVideoMute}
              showMute={true}
              playFunctionality={true}
              row={mediaData}
              isModal={true}
              backgroundBlur={true}
              style={{
                height: '100%',
                width: '100%',
                objectFit: 'contain',
                maxHeight: isGoogle ? '90vh' : '100%',
                borderRadius: 0,
                background: 'black',
              }}
            />
          </idk-div>
          {mediaData.products?.length > 0 && (
            <idk-div class="inspiration_product">
              <idk-p class="zid-pt-4 zid-pb-8 zid-text-xl zid-text-center zid-border-b zid-border-b-[#d7d7d7] zid-font-semibold zid-mb-4">
                Product List
              </idk-p>
              <idk-div class="zid-flex zid-flex-col zid-gap-6">
                {mediaData.products.map((product, index) => (
                  <idk-div
                    class="zid-flex zid-flex-col zid-px-4 zid-justify-between zid-border-b zid-border-b-[#d7d7d7] zid-col-gap-4 zid-pb-4"
                    key={`inspiration_product_${index}`}
                  >
                    <idk-div class="zid-flex zid-gap-4">
                      <idk-div class="inspiration_product_image">
                        <img
                          src={(() => {
                            const raw =
                              product.image ||
                              product.images?.[0]?.src ||
                              product.variants?.[0]?.featured_image?.src ||
                              product.variants?.[0]?.featured_media?.preview_image?.src ||
                              product.media?.[0]?.src ||
                              '';

                            const first = raw.split(',')[0].trim();

                            return first.includes('cdn.shopify.com')
                              ? first + (first.includes('?') ? '&width=96' : '?width=96')
                              : first;
                          })()}
                          alt={product.title || product.variants?.[0]?.featured_image?.alt || 'Product image'}
                        />
                      </idk-div>
                      <idk-div class="zid-flex zid-flex-col zid-gap-1">
                        <idk-p class="inspiration_product_title zid-w-[150px] zid-break-words">{product.title}</idk-p>
                        <idk-div class="inspiration_product_price">
                          {shopifyData ? (
                            <>
                              {product.variants?.[0]?.compare_at_price > product.variants?.[0]?.price && (
                                <idk-div class="zid-line-through zid-me-2 zid-text-red-400 zid-text-sm zid-original-price">
                                  {layout?.productsSettings?.currencySymbol
                                    ? layout?.productsSettings?.currencySymbol
                                    : shopifyData?.currency?.active &&
                                      getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                  {calculatePrice(
                                    parseFloat(product.variants?.[0]?.compare_at_price) / 100,
                                    parseFloat(shopifyData?.currency?.rate),
                                  )}
                                </idk-div>
                              )}
                              <idk-div
                                class={`${
                                  product.variants?.[0]?.compare_at_price > product.variants?.[0]?.price
                                    ? 'zid-discounted-price'
                                    : 'zid-regular-price'
                                }`}
                              >
                                {layout?.productsSettings?.currencySymbol
                                  ? layout?.productsSettings?.currencySymbol
                                  : shopifyData?.currency?.active &&
                                    getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                {calculatePrice(
                                  parseFloat(product.variants?.[0]?.price) / 100,
                                  parseFloat(shopifyData?.currency?.rate),
                                )}
                              </idk-div>
                            </>
                          ) : (
                            <PriceDisplay
                              price={product.variants?.[0]?.price}
                              salePrice={product.variants?.[0]?.salePrice}
                              currency={data.result.currency}
                              staticCurrency={layout?.productsSettings?.currencySymbol}
                              discountPriceOnRight={layout?.productsSettings?.showDiscountPriceOnRight}
                            />
                          )}
                        </idk-div>
                        <button
                          onClick={() => {
                            window.open(
                              shopifyData
                                ? addUTMToURL(
                                    `https://${window.location.host}/products/${mediaData.products[0]?.handle}`,
                                    {
                                      utm_source: layout?.gallerySettings?.utmSource,
                                      utm_medium: layout?.gallerySettings?.utmMedium,
                                      utm_campaign: layout?.gallerySettings?.utmCampaign,
                                    },
                                  )
                                : `${mediaData.products[0]?.product_url}?utm_source=${
                                    layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                  }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                                    layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                  }`,
                              '_blank',
                            );
                          }}
                          className="inspiration_shop_btn"
                        >
                          Shop Here
                        </button>
                      </idk-div>
                    </idk-div>
                  </idk-div>
                ))}
              </idk-div>
              {mediaData?.permalink && mediaData?.permalink != '0' && (
                <idk-div class="inspiration-social zid-flex zid-flex-col zid-items-center zid-gap-8">
                  <SourceIcon socialUrl={mediaData?.permalink} fontSize={48} />
                  {mediaData?.username != '0' && <idk-p class="zid-font-bold">{mediaData?.username}</idk-p>}
                </idk-div>
              )}
            </idk-div>
          )}
        </idk-div>
      </idk-div>
    </idk-div>
  );
}
